window.Popup = require('../../commons/popup');

/**
 * Module for RoHS certificate on product page
 */
module.exports = {

	/**
	 * initlization
	 */
	init: function(techRef) {
		var self = this;

		$.extend(self, techRef);

		var popup = new Popup({
			$container: $('.RoSH', techRef.$el),
			bodySelector: '#rohsCertificate',
			linkSelector: '.rohs-certificate-link',
			bodyCls: 'rohs-cert-dialog',
			printBtnSelector: '.rohsCertPrint',
			printDivId: 'rohsCertificateDiv'
		});

		self._initRoshPrintButton(popup);
	},

	_initRoshPrintButton: function(popup) {
		var $btn = $('.rohsCertPrint', popup.$body);

		$btn.addClass('btn btn-default btn-print');
	}
};



//////////////////
// WEBPACK FOOTER
// ./src/main/ui/core/js/modules/product/tech-ref/rohs.js
// module id = 249
// module chunks = 6